import Alpine from "alpinejs";

Alpine.store("FormUploadFields", {
    activeFields: {},

    setFieldActive(namespace, index) {
        if (!this.activeFields[namespace]) {
            this.activeFields[namespace] = {};
        }
        this.activeFields[namespace]["fieldIndex_" + index] = true;
        console.log("store setFieldActive done", this.activeFields);
    },
    setFieldInactive(namespace, index) {
        delete this.activeFields[namespace]["fieldIndex_" + index];
    },

    isFieldVisible(namespace, index) {
        try {
            if (index === 0) {
                return true;
            }

            return (
                this.activeFields[namespace] &&
                (this.activeFields[namespace]["fieldIndex_" + index] ||
                    this.activeFields[namespace]["fieldIndex_" + (index - 1)] ||
                    this.activeFields[namespace]["fieldIndex_" + (index + 1)])
            );
        } catch (e) {
            return false;
        }
    },
});

Alpine.data("FormUpload", (namespace, index) => ({
    namespace: namespace,
    index: index,
    label: "",
    inputFile: null,
    visible: false,

    init() {
        Alpine.bind(this.$root, this.root);
        this.files = [];
        this.label = this.inputFile
            ? this.inputFile?.name
            : this.$refs.label.dataset.uploaded
            ? this.$refs.label.dataset.uploaded
            : this.$refs.label.dataset.label;

        if (this.$refs.label.dataset.uploaded) {
            this.inputFile = true;
            this.$store.FormUploadFields.setFieldActive(this.namespace, this.index);
        }

        this.visible = this.$store.FormUploadFields.isFieldVisible(this.namespace, this.index);
        this.$watch("$store.FormUploadFields.activeFields", () => {
            this.visible = this.$store.FormUploadFields.isFieldVisible(this.namespace, this.index);
        });
    },
    changeFile(event) {
        this.inputFile = event.target.files[0];
        this.label = this.inputFile
            ? this.inputFile.name
            : this.$refs.label.dataset.uploaded
            ? this.$refs.label.dataset.uploaded
            : this.$refs.label.dataset.label;

        this.$store.FormUploadFields.setFieldActive(this.namespace, this.index);
        this.removeUploadedResource();
        this.removeErrors();
    },
    clearInput() {
        this.$refs.fileInput.value = "";
        this.inputFile = null;
        this.label = this.$refs.label.dataset.label;
        this.$store.FormUploadFields.setFieldInactive(this.namespace, this.index);
        this.removeUploadedResource();
        this.removeErrors();
    },

    removeUploadedResource() {
        if (this.$refs.uploadedResource) {
            this.$refs.uploadedResource.remove();
        }
    },
    addError(error) {
        this.$root.parentElement.classList.add("c-form-field--error");
        if (!this.$root.parentElement.querySelector(".c-form-field-errors")) {
            const errorElement = document.createElement("div");
            errorElement.classList.add("c-form-field-errors");
            errorElement.innerText = error;
            this.$root.parentElement.appendChild(errorElement);
        }
    },
    removeErrors() {
        this.$root.parentElement.classList.remove("c-form-field--error");
        if (this.$root.parentElement.querySelector(".c-form-field-errors")) {
            this.$root.parentElement.querySelector(".c-form-field-errors").remove();
        }
    },
    root: {
        ["x-on:fielderror"]: function (event) {
            this.addError(event.detail);
        },
    },
}));
